import { limitNumber } from "./limitNumber";

// Code from https://learnersbucket.com/examples/interview/convert-hex-color-to-rgb-in-javascript/
export function hexToRGB(hex: string) {
    if(hex === undefined) return { r: 0, g: 0, b: 0 };  
    // Remove the hash if present
    hex = hex.replace(/^#/, "");

    // If the hex code is short, expand it
    if (hex.length === 3) {
        hex = hex
            .split("")
            .map((char) => char + char)
            .join("");
    }

    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);

    return { r, g, b };
}

// Input alpha is 0-1
export function hexToRGBA(hex: string, alpha: number): string {
    const rgb = hexToRGB(hex);
    const alphaFormatted = limitNumber(alpha, 0, 1);
    return `rgba(${rgb.r},${rgb.g},${rgb.b},${alphaFormatted})`;
}

/**
 * Mixes two colors together using a percentage to determine the proportion of each color in the output.
 * @param color1 The first color to mix.
 * @param color2 The second color to mix.
 * @param percentage1 The percentage of color1 to use in the mix. Defaults to 50.
 * @returns The mixed color, returned as a hex string.
 */
export function mixColors(color1: string, color2: string, percentage1: number = 0.5) {
    const rgb1 = hexToRGB(color1);
    const rgb2 = hexToRGB(color2);
    const percentage1_ = limitNumber(percentage1, 0, 1);
    const percentage2_ = 1 - percentage1_;
    const rgbMixed = {
        r: (rgb1.r * percentage1_ + rgb2.r * percentage2_),
        g: (rgb1.g * percentage1_ + rgb2.g * percentage2_),
        b: (rgb1.b * percentage1_ + rgb2.b * percentage2_),
    };
    return rgbToHex(rgbMixed);
}

export function checkValidHex(color: string) {
    let Reg_Exp = /(^[0-9A-F]{6}$)|(^[0-9A-F]{3}$)/i;
    return Reg_Exp.test(color);
}

// Code from: https://stackoverflow.com/a/5624139
export function rgbToHex(rgb: {r: number, g: number, b: number}) {
    return "#" + ((1 << 24) | (rgb.r << 16) | (rgb.g << 8) | rgb.b).toString(16).slice(1);
}


export function validateColor(color: string){
    let validatedColor_ = color.toLowerCase().trim();

    while (validatedColor_.includes("#")) {
        validatedColor_ = validatedColor_.replace("#", "");
    }

    return validatedColor_
}